import { render, staticRenderFns } from "./ShippingBar.vue?vue&type=template&id=152c3408&"
import script from "./ShippingBar.vue?vue&type=script&lang=js&"
export * from "./ShippingBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports